module.exports = "<div class=\"wrapper\">\n  <div class=\"header\">\n    <div>\n      <a href=\"http://www.quickscore.co.uk\"><img class=\"logo\" src=\"/public/assets/QSLogoFinalHD.jpg\"/></a>\n    </div>\n    \n    <div class=\"title\">\n      <h4> Quickscore Live Mirroring </h4> <small><i>(BETA)</i></small>\n    </div>\n  </div>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 410
// module chunks = 2